import { render, staticRenderFns } from "./tickets-tab.vue?vue&type=template&id=6db2d47b&scoped=true&"
import script from "./tickets-tab.vue?vue&type=script&lang=js&"
export * from "./tickets-tab.vue?vue&type=script&lang=js&"
import style0 from "./tickets-tab.vue?vue&type=style&index=0&id=6db2d47b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2d47b",
  null
  
)

export default component.exports